import { DateTimeFormatter } from '@nile/components/src';
import { SVGIcon } from '@superops/super-icons';
import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import Tippy from '@tippyjs/react';

const SLAEvent = (props) => {
  const workItem = props?.event?.workItem;
  return (
    <Tippy
      placement="bottom-start"
      allowHTML
      content={
        <div className="pl-15 pr-15 pt10 pb10 flex g10">
          <div>
            <TextStyle variation="subdued">#{workItem?.displayId}</TextStyle>
          </div>
          <div>
            <TextStyle weight="Medium">{workItem?.subject}</TextStyle>
          </div>
        </div>
      }
      theme="light"
    >
      <div className="sla-event" id="sla-event-component">
        <div className="sla-svg">
          <SVGIcon name="HourglasswireEnd" color="#DE3730" />
        </div>
      </div>
    </Tippy>
  );
};

export default SLAEvent;
